import React from 'react';
import { useHistory } from 'react-router-dom';
import { resetHealthGoals } from '../../services';
import { useSelector } from 'react-redux';

export default function ResetWorkoutButton({ setLoading }) {
  const history = useHistory();
  const authToken = useSelector((state) => state.user.authToken);
  const handleReset = async () => {
    try {
      setLoading(true);
      await resetHealthGoals(authToken);
      history.push('/health-content/fitness-home');
    } catch (err) {
      console.error('Error resetting health goals:', err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <button
      className="border border-txtsecondary-shades7 rounded-20 py-1 px-2 text-body-s text-primary font-medium clickable "
      onClick={handleReset}
    >
      Reset Workout
    </button>
  );
}
